import { createNavigationContainerRef } from '@react-navigation/native';
import type { RootNavigation } from 'src/presentation/navigation/types/NavigationTypes';

export const navigationRef = createNavigationContainerRef<RootNavigation>();
